import { TYPES } from 'action-types/customerToggle';
import { ICustomerToggleModel } from 'reducers/customerToggle/models';
import * as msgs from '../../constants/validationMessages';

export interface ICustomerToggleAction {
	readonly type: string;
	readonly errors?: string | string[];
	readonly customerToggle: ICustomerToggleModel[];
}

export interface ICustomerToggleState {
	readonly isFetchDataLoading: boolean;
	readonly isCustomerToggleDataReady: boolean;
	readonly isFetchDataError: boolean;
	readonly pendingError: string | string[];
	readonly customerToggle: ICustomerToggleModel[];
}

export const defaultState: ICustomerToggleState = {
	isFetchDataError: false,
	pendingError: '',
	isFetchDataLoading: false,
	isCustomerToggleDataReady: false,
	customerToggle: [],
};

export const reducer = (
	state: ICustomerToggleState = defaultState,
	action: ICustomerToggleAction,
): ICustomerToggleState => {
	switch (action.type) {
		case TYPES.FETCH_CUSTOMER_TOGGLES_DATA.PENDING:
			return {
				...state,
				customerToggle: defaultState.customerToggle,
				isFetchDataLoading: true,
				isFetchDataError: false,
				isCustomerToggleDataReady: false,
				pendingError: '',
			};
		case TYPES.FETCH_CUSTOMER_TOGGLES_DATA.FULFILLED:
			return {
				...state,
				customerToggle: action.customerToggle,
				isFetchDataLoading: false,
				isFetchDataError: false,
				isCustomerToggleDataReady: true,
				pendingError:
					action.customerToggle &&
					action.customerToggle.length > 0
						? ''
						: msgs.ExtraDocument
								.Pending_Error,
			};
		case TYPES.FETCH_CUSTOMER_TOGGLES_DATA.REJECTED:
			return {
				...state,
				customerToggle: defaultState.customerToggle,
				isFetchDataLoading: false,
				isFetchDataError: true,
				isCustomerToggleDataReady: true,
				pendingError:
					action.errors && action.errors.length
						? action.errors.toString()
						: msgs.ExtraDocument.Error_Msg,
			};
		default:
			return state;
	}
};
